import "../assets/Input.css";
import { defineComponent as V, useCssVars as g, unref as b, ref as n, computed as R, openBlock as w, createElementBlock as B, createVNode as k, createElementVNode as d, toDisplayString as q, withDirectives as E, vModelDynamic as M } from "vue";
import { _ as C } from "./Tooltip.vue_vue_type_style_index_0_lang.CQgCKEVm.js";
import { e as D } from "./useStore.DvPy8fc7.js";
const N = {
  class: "thn--tool-input",
  ref: "rootRef"
}, T = ["for"], I = ["required", "disabled", "type", "name", "id", "error", "placeholder"], s = 10, $ = /* @__PURE__ */ V({
  __name: "Input",
  props: {
    placeholder: { default: "" },
    type: {},
    errorMessage: { default: "" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(u, { expose: p, emit: f }) {
    g((e) => ({
      "0493ee84": b(D)(s)
    }));
    const i = u, c = f, t = n(), r = n(), a = R({
      get: () => i.modelValue,
      set: (e) => {
        c("update:modelValue", e);
      }
    });
    function m() {
      r.value.hide();
    }
    function h() {
      var o;
      const {
        top: e,
        left: l
      } = ((o = t.value) == null ? void 0 : o.getBoundingClientRect()) || {};
      r.value.show(i.errorMessage, {
        top: e,
        left: l + s
      });
    }
    function v() {
      const e = t.value.validity.valid;
      return e || h(), e;
    }
    function y() {
      t.value.value = "";
    }
    return p({
      clear: y,
      validate: v
    }), (e, l) => {
      var o;
      return w(), B("div", N, [
        k(C, {
          ref_key: "errorTooltipRef",
          ref: r,
          "auto-hide": 3e3
        }, null, 512),
        d("label", {
          class: "sr-only",
          for: e.id
        }, q(e.placeholder), 9, T),
        E(d("input", {
          role: "textbox",
          class: "thn--tool-input__input",
          ref_key: "inputRef",
          ref: t,
          dir: "auto",
          required: e.required,
          disabled: e.disabled,
          type: e.type || "email",
          name: e.type || "email",
          id: e.id,
          error: (o = r.value) == null ? void 0 : o.showing,
          placeholder: e.placeholder,
          "onUpdate:modelValue": l[0] || (l[0] = (_) => a.value = _),
          onMousedown: m
        }, null, 40, I), [
          [M, a.value]
        ])
      ], 512);
    };
  }
});
export {
  $ as _
};
//# sourceMappingURL=Input.vue_vue_type_style_index_0_lang.CpepcVjg.js.map
